/* globals window document */

/**
 * Returns the CSS breakpoint config
 * @return {String}
 */
const getCssBreakpointConfig = () => {
  const cssBreakpointConfig = window
    .getComputedStyle(document.querySelector('html'), ':before')
    .getPropertyValue('content')
    .replace(/"|'/g, '');

  return cssBreakpointConfig
    .split('|')
    .filter(breakpoint => breakpoint)
    .map((breakpoint) => {
      const breakpointParts = breakpoint.split(':');
      const name = breakpointParts[0];
      const value = (breakpointParts[1] || '').replace('px', '');

      return { name, value };
    });
};

export default getCssBreakpointConfig;



// WEBPACK FOOTER //
// ./resources/assets/js/utils/getCssBreakpointConfig.js